export const filterInputByType = (input, inputType) => {
  if (inputType === 'integer') {
    return input.replace(/[^\d-]/g, '');
  }
  return input.replace(/[^\d.,-]/g, '');
};